// To config available list views

const availableListViewsConfig = {
  "table": true
}

export default availableListViewsConfig;